import type { League } from '@h2h/shared';
import { Check, Lock } from '../../components/ui/icons';
import { NationalFlagEmblem } from '../../components/ui/NationalFlagEmblems';
import { useCurrentRound } from '../../hooks/useQueries';
import { cyclingLeagueMetaLine } from '../../lib/cyclingSchedule';
import { isRoundInPlay } from './helpers';

export function CyclingRaceRow({
  league,
  joined,
  unread,
  onPlay
}: {
  league: League;
  joined: boolean;
  unread: number;
  onPlay: () => void;
}) {
  const { data: round } = useCurrentRound(league.leagueId, league.currentRoundId);

  if (isRoundInPlay(round)) return null;

  const metaLine = cyclingLeagueMetaLine(league);

  const handle = () => {
    if (!joined) return;
    onPlay();
  };

  return (
    <button
      type="button"
      onClick={handle}
      disabled={!joined}
      className="flex w-full items-center gap-[13px] rounded-[18px] border border-black/7 bg-fill/60 p-[12px_14px] text-left disabled:cursor-default"
    >
      <div className="relative shrink-0">
        <NationalFlagEmblem
          leagueId={league.leagueId}
          country={league.country}
          slug={league.cycling?.slug}
          size="sm"
          muted={!joined}
        />
        {unread > 0 && (
          <span className="absolute -right-[3px] -top-[3px] h-[10px] w-[10px] rounded-full border-2 border-white bg-accent" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-bold tracking-[-0.01em] text-ink2">{league.name}</div>
        <div className="truncate text-[12px] font-medium text-ink3">{metaLine}</div>
      </div>
      {joined ? (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-accent-wash px-[10px] py-[6px] text-[11px] font-extrabold text-accent-ink">
          <Check width={12} height={12} strokeWidth={3.2} />
          Joined
        </span>
      ) : (
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-fill px-[10px] py-[6px] text-[11px] font-bold text-ink3">
          <Lock width={12} height={12} strokeWidth={2.4} />
          Soon
        </span>
      )}
    </button>
  );
}
